export const superscriptCharHTML = (string: string, char: string) =>
  string.replace(char, `<sup>${char}</sup>`)
